import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import './style.scss';
import React from 'react';
import ThreeButtons from '../ThreeButtons';
import TimeFrame from '../TimeFame';
import Tag from '../Tag';

const Item = ({ item, props }) => {
  const title = item?.fields?.title;
  const description = item?.fields?.description;
  const image = item?.fields?.image;
  const shouldRenderImage =
    (!!image?.src && image?.src !== '') || (!!image?.value?.src && !!image?.value?.src !== '');
  const shouldRenderTitle = !!description?.value && description !== '';
  const shouldRenderDescription = !!title?.value && title !== '';

  const offerCategories = item?.fields?.tags?.targetItems;

  let btnPrimary = item?.fields?.primaryButton;
  const primaryButton = btnPrimary?.value === undefined ? { value: { ...btnPrimary } } : btnPrimary;

  let btnSecondary = item?.fields?.secondaryButton;
  const secondaryButton =
    btnSecondary?.value === undefined ? { value: { ...btnSecondary } } : btnSecondary;

  let btnTertiary = item?.fields?.tertiaryButton;
  const tertiaryButton =
    btnTertiary?.value === undefined ? { value: { ...btnTertiary } } : btnTertiary;

  return (
    <div className={clsx('item-card-image-text flex-it flex-align-item-stretch')}>
      <div className="icit-text-part flex-it flex-align-item-center">
        <div className="auto">
          {offerCategories?.length > 0 && (
            <div className="icit-tags">
              {offerCategories?.map((item, index) => {
                return <Tag key={index} item={item} selectedTags={[]} />;
              })}
            </div>
          )}
          {shouldRenderTitle && <RichText className="icit-title" field={title} />}
          {shouldRenderDescription && <RichText className="icit-description" field={description} />}
          <TimeFrame
            props={props}
            validityEnd={item?.fields?.validityEnd}
            validityStart={item?.fields?.validityStart}
            theme={''}
          />
          <ThreeButtons {...{ primaryButton, secondaryButton, tertiaryButton, theme: '' }} />
        </div>
      </div>
      {shouldRenderImage && (
        <div className="icit-image-part">
          <Image field={image} />
        </div>
      )}
    </div>
  );
};

export default Item;
